// eslint-disable-next-line
// @ts-ignore
import Audio from '@/audio-bus';
// eslint-disable-next-line
// @ts-ignore
import { generate as shortid } from 'shortid';

const { AudioBus, Playlist } = Audio;

function AudioElement() {
  return {
    props: {
      audioName: {
        type: String,
        default: shortid(),
      },
      audioFile: String,
    },
    computed: {
      // eslint-disable-next-line
      // @ts-ignore
      playing() {
        // eslint-disable-next-line
        // @ts-ignore
        return AudioBus.playing && AudioBus.currentlyPlaying === this.audioName;
      },
    },
    methods: {
      toggleAudio() {
        if (AudioBus.playing) {
          // eslint-disable-next-line
          // @ts-ignore
          Playlist.pause();
        } else {
          this.play();
        }
      },
      toggleAudioHard() {
        // eslint-disable-next-line
        // @ts-ignore
        Playlist.stop();
        this.play();
      },
      play() {
        // eslint-disable-next-line
        // @ts-ignore
        Playlist.play(this.audioName);
      },
      stop() {
        // eslint-disable-next-line
        // @ts-ignore
        Playlist.stop();
      },
    },
    mounted() {
      // eslint-disable-next-line
      // @ts-ignore
      Playlist.addAudio(
        // eslint-disable-next-line
        // @ts-ignore
        this.$props.audioName,
        // eslint-disable-next-line
        // @ts-ignore
        this.$props.audioFile,
      );
    },
  };
}

export default AudioElement;
